import RepositoryService from 'src/services/repository'

const resource = 'networkDiagram/session'

export default {
  ...RepositoryService.utils.createCrudRepository(resource),
  sendAction: async ({ gameId, actionName }) => {
    const actionPath = `${resource}/${gameId}/${actionName}`

    const response = await RepositoryService.base.post(actionPath)

    return response?.data ?? response
  },
}
